var distances = require("./distance");

export class HierarchicalClustering {
   constructor(distance, linkage, threshold) {
      this.distance = distance;
      this.linkage = linkage;
      this.threshold = threshold == undefined ? Infinity : threshold;
   }

   myDists(correlMat, correlWeight, euclideanMat, euclideanWeight, cosMat, cosWeight) {
      if(!(correlWeight + euclideanWeight +cosWeight > 0.999 && correlWeight + euclideanWeight+cosWeight < 1.001)) {
         throw "weights have to sum up to 1!"
      }
      const dists = [];
      const mins = [];

      for (var i = 0; i < correlMat.length; i++) {
         dists[i] = [];
         mins[i] = 0;
      }

      for (var i = 0; i < correlMat.length; i++) {
         for (var j = 0; j <= i; j++) {
            var dist = (i == j) ? Infinity : 
            (1.0 - correlMat[i][j]) * correlWeight + 
            euclideanMat[i][j] * euclideanWeight +
            cosMat[i][j] * cosWeight ; // correlation == 1.0 -> distance = 0
            dists[i][j] = dist;
            dists[j][i] = dist;

            if (dist < dists[i][mins[i]]) {
               mins[i] = j;               
            }
         }
      }

      return {dists:dists, mins:mins}
   }

   myCluster (dists, mins, snapshotPeriod, snapshotCb) {
      const clusters = [];
      const index = []; // keep a has h of all clusters by key
      
      for (var i = 0; i < dists.length; i++) {
         var cluster = {
            value: i,
            key: i,
            index: i,
            size: 1
         };
         clusters[i] = cluster;
         index[i] = cluster;
      }

      var merged = this.mergeClosest(clusters, dists, index, mins);
      var i = 0;
      while (merged) {
        if (snapshotCb && (i++ % snapshotPeriod) == 0) {
           snapshotCb(clusters);           
        }
        merged = this.mergeClosest(clusters, dists, index, mins);
      }
    
      clusters.forEach(function(cluster) {
        // clean up metadata used for clustering
        delete cluster.key;
        delete cluster.index;
      });

      return clusters;
   }

   cluster (items, snapshotPeriod, snapshotCb) {
      this.clusters = [];
      this.dists = [];  // distances between each pair of clusters
      this.mins = []; // closest cluster for each cluster
      this.index = []; // keep a hash of all clusters by key
      
      for (var i = 0; i < items.length; i++) {
         var cluster = {
            value: items[i],
            key: i,
            index: i,
            size: 1
         };
         this.clusters[i] = cluster;
         this.index[i] = cluster;
         this.dists[i] = [];
         this.mins[i] = 0;
      }

      for (var i = 0; i < this.clusters.length; i++) {
         for (var j = 0; j <= i; j++) {
            var dist = (i == j) ? Infinity : 
               this.distance(this.clusters[i].value, this.clusters[j].value);
            this.dists[i][j] = dist;
            this.dists[j][i] = dist;

            if (dist < this.dists[i][this.mins[i]]) {
               this.mins[i] = j;               
            }
         }
      }

      var merged = this.mergeClosest();
      var i = 0;
      while (merged) {
        if (snapshotCb && (i++ % snapshotPeriod) == 0) {
           snapshotCb(this.clusters);           
        }
        merged = this.mergeClosest();
      }
    
      this.clusters.forEach(function(cluster) {
        // clean up metadata used for clustering
        delete cluster.key;
        delete cluster.index;
      });

      return this.clusters;
   }
  
   mergeClosest(clusters, dists, index, mins) {
      // find two closest clusters from cached mins
      var minKey = 0, min = Infinity;
      for (var i = 0; i < clusters.length; i++) {
         var key = clusters[i].key,
             dist = dists[key][mins[key]];
         if (dist < min) {
            minKey = key;
            min = dist;
         }
      }
      if (min >= this.threshold) {
         return false;         
      }

      var c1 = index[minKey],
          c2 = index[mins[minKey]];

      // merge two closest clusters
      var merged = {
         left: c1,
         right: c2,
         key: c1.key,
         size: c1.size + c2.size
      };

      clusters[c1.index] = merged;
      clusters.splice(c2.index, 1);
      index[c1.key] = merged;

      // update distances with new merged cluster
      for (var i = 0; i < clusters.length; i++) {
         var ci = clusters[i];
         var dist;
         if (c1.key == ci.key) {
            dist = Infinity;            
         }
         else if (this.linkage == "single") {
            dist = dists[c1.key][ci.key];
            if (dists[c1.key][ci.key] > dists[c2.key][ci.key]) {
               dist = dists[c2.key][ci.key];
            }
         }
         else if (this.linkage == "complete") {
            dist = dists[c1.key][ci.key];
            if (dists[c1.key][ci.key] < dists[c2.key][ci.key]) {
               dist = dists[c2.key][ci.key];              
            }
         }
         else if (this.linkage == "average") {
            dist = (dists[c1.key][ci.key] * c1.size
                   + dists[c2.key][ci.key] * c2.size) / (c1.size + c2.size);
         }
         else {
            dist = this.distance(ci.value, c1.value);            
         }

         dists[c1.key][ci.key] = dists[ci.key][c1.key] = dist;
      }

    
      // update cached mins
      for (var i = 0; i < clusters.length; i++) {
         var key1 = clusters[i].key;        
         if (mins[key1] == c1.key || mins[key1] == c2.key) {
            var min = key1;
            for (var j = 0; j < clusters.length; j++) {
               var key2 = clusters[j].key;
               if (dists[key1][key2] < dists[key1][min]) {
                  min = key2;                  
               }
            }
            mins[key1] = min;
         }
         clusters[i].index = i;
      }
    
      // clean up metadata used for clustering
      delete c1.key; delete c2.key;
      delete c1.index; delete c2.index;

      return true;
   }
}

export function hcluster (items, distance, linkage, threshold, snapshot, snapshotCallback) {
   distance = distance || "euclidean";
   linkage = linkage || "average";

   if (typeof distance == "string") {
     distance = distances[distance];
   }
   var clusters = (new HierarchicalClustering(distance, linkage, threshold))
                  .myCluster(items, snapshot, snapshotCallback);
      
   if (threshold === undefined) {
      return clusters[0]; // all clustered into one
   }
   return clusters;
}

export const leaves = (hcluster) => {
   // flatten cluster hierarchy
   if(!hcluster.left)
     return [hcluster.value];
   else
     return leaves(hcluster.left).concat(leaves(hcluster.right));
 }